module.exports = __webpack_public_path__ + "img/working-time.ca6f17bb.svg";